import { useEffect } from 'react'
import Modal from 'react-modal'
import cyclopsImage from '../../../assets/images/cyclops.png'
import { useKeyboardControls } from '../../../contexts/KeyboardControlsContext'
import { HighlightEffect } from '../../../enums/KeyboardControls'
import { Button } from '../../atoms'
import { KeyboardControl } from '../KeyboardControls'
import ControlHighlight from '../KeyboardControls/ControlHighlight'

interface MessageModalProps {
  id: string
  onCtaClick: () => void
  children: React.ReactElement | JSX.Element[]
  isOpen: boolean
  ctaText: string
  onRequestClose: () => void
}

const MessageModal: React.FunctionComponent<MessageModalProps> = ({
  id,
  onCtaClick,
  children,
  onRequestClose,
  isOpen,
  ctaText
}) => {
  const keyboardControls = useKeyboardControls()

  const idButton = `button-${id}`

  useEffect(() => {
    const focusButton = (): void => {
      if (keyboardControls.getFocusedElement() !== idButton) {
        keyboardControls.setFocusedElement(idButton)
      }
    }

    focusButton()
  }, [keyboardControls, idButton])

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} className=' bg-black absolute inset-x-0 inset-y-0' ariaHideApp={false}>
      <div className='flex flex-col justify-center items-center h-full w-full relative'>
        <img src={cyclopsImage} alt='cyclops' className='h-[24vh] -mb-1 z-10' />
        <div className='diamond-corner bg-[#DCB900] h-[34vh] w-3/4 flex justify-center items-center flex-col p-[12vh]'>
          {children}
        </div>
        <ControlHighlight
          active={keyboardControls.isEnabled && keyboardControls.isElementFocused(idButton)}
          highlightEffect={HighlightEffect.ButtonHexOutline}
          className='flex justify-center mt-[12vh]'
        >
          <KeyboardControl>
            <Button
              id={idButton}
              data-testid={idButton}
              className='justify-center diamond-btn sm:h-[6vh] h-[8vh] w-52 rounded-lg font-bold p-7 flex items-center'
              bgColor='bg-dopage-primary'
              onClick={onCtaClick}
            >
              <span className='lg:text-xl md:text-lg text-sm font-extrabold'>{ctaText}</span>
            </Button>
          </KeyboardControl>
        </ControlHighlight>
      </div>
    </Modal>
  )
}

export default MessageModal
